module.exports = __webpack_public_path__ + "img/オペレーティングシステム2-1.cc4fe09a.png";